import { RisError } from '../client';

/**
 * Failures every assistant call can hit, worded the same wherever they show: ris rate-limits the
 * model (429 errors.ai.rate_limited), the hub gives up on a slow answer (504
 * errors.presiai.viewer_timeout), the org's wallet is empty (402), the model is not configured (503).
 */
export const AI_LIMIT_TEXT = {
  rateLimited: 'Demasiadas consultas al Asistente Guru; espera unos minutos.',
  timeout: 'El Asistente Guru tardó demasiado; intenta de nuevo.',
  noBalance: 'Saldo insuficiente para el Asistente Guru.',
  unavailable: 'El Asistente Guru no está disponible en este momento.',
} as const;

const PAYMENT_REQUIRED = 402;
const RATE_LIMITED = 429;
const SERVICE_UNAVAILABLE = 503;
const GATEWAY_TIMEOUT = 504;

/** The message for a rate-limit or timeout answer, or null for any other failure. */
export function aiLimitText(error: unknown): string | null {
  if (!(error instanceof RisError)) return null;
  if (error.status === RATE_LIMITED || error.detail.includes('errors.ai.rate_limited')) return AI_LIMIT_TEXT.rateLimited;
  if (error.status === GATEWAY_TIMEOUT || error.detail.includes('errors.presiai.viewer_timeout')) return AI_LIMIT_TEXT.timeout;
  return null;
}

/**
 * The message for a stream `error` event, by the `status` ris puts on it (402 wallet empty, 429, 503
 * not configured, 504), or null for any other: the caller keeps its generic text then.
 */
export function streamErrorText(status: number | null, detail = ''): string | null {
  if (status === PAYMENT_REQUIRED) return AI_LIMIT_TEXT.noBalance;
  if (status === SERVICE_UNAVAILABLE) return AI_LIMIT_TEXT.unavailable;
  return aiLimitText(new RisError(status ?? 0, detail));
}
